// --- IGNORE --- File will be deleted after testing/debugging is complete on production as SEM pdp traffic can only be tested on production from Google ads.

import UniversalCookie from 'universal-cookie';
import logger from '@helpers/utils/logger/client';

const cookies = new UniversalCookie();

export function getQueryParamsFromCookie(): URLSearchParams {
  try {
    const cookieValue = cookies.get('queryParam');
    logger.info('[queryParamCookie] Reading cookie', {
      cookieValue,
      cookieExists: !!cookieValue,
      cookieType: typeof cookieValue,
    });

    if (!cookieValue || typeof cookieValue !== 'string') {
      logger.info('[queryParamCookie] No valid cookie found, returning empty URLSearchParams');
      return new URLSearchParams();
    }

    const params = new URLSearchParams(cookieValue);
    logger.info('[queryParamCookie] Parsed params from cookie', {
      paramCount: Array.from(params.keys()).length,
      allParams: Array.from(params.entries()),
    });

    return params;
  } catch (error) {
    logger.error('[queryParamCookie] Error reading cookie', error);
    return new URLSearchParams();
  }
}

export function getQueryParamFromCookie(paramName: string): string | null {
  const params = getQueryParamsFromCookie();
  const value = params.get(paramName);
  logger.info('[queryParamCookie] Getting param', {
    paramName,
    value,
    found: !!value,
  });
  return value;
}

export function getAllQueryParamsFromCookie(): Record<string, string> {
  const params = getQueryParamsFromCookie();
  const result: Record<string, string> = {};
  params.forEach((value, key) => {
    result[key] = value;
  });
  logger.info('[queryParamCookie] All params as object', result);
  return result;
}

export function debugQueryParamCookie(): void {
  if (typeof window === 'undefined') {
    return;
  }

  logger.info('[queryParamCookie] Debug check', {
    currentUrl: window.location.href,
    urlSearchParams: Array.from(new URLSearchParams(window.location.search).entries()),
    cookieExists: !!cookies.get('queryParam'),
    cookieValue: cookies.get('queryParam'),
    allCookies: document.cookie,
  });

  const allParams = getAllQueryParamsFromCookie();
  logger.info('[queryParamCookie] Final parsed params', {
    gclid: allParams.gclid || null,
    fbclid: allParams.fbclid || null,
    utm_source: allParams.utm_source || null,
    utm_medium: allParams.utm_medium || null,
    allParams,
  });
}
